import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Weather Subscription Service',
		description:
			'Monetize the weather. Rain now requires a monthly subscription fee.'
	},
	{
		name: 'Cloud Microtransactions',
		description:
			'Each cloud requires a separate purchase. Premium clouds have silver linings.'
	},
	{
		name: 'Quantum Weather Patterns',
		description:
			"It's simultaneously raining and sunny until someone checks the forecast."
	},
	{
		name: 'Seasonal DLC Package',
		description:
			'Spring, Summer, and Fall now require separate purchases. Winter is a pre-order bonus.'
	},
	{
		name: 'Time-Traveling Thermostats',
		description:
			'Control the temperature of the past. Yesterday is now 5 degrees warmer.'
	},
	{
		name: 'Multiverse Weather System',
		description:
			"Import weather from parallel universes. Tuesday's forecast: Purple rain with a chance of floating islands."
	},
	{
		name: 'Void Climate Control',
		description:
			'Harness the endless void for temperature regulation. Side effects may include existential dread.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Climate Control Corporation'],
	departments[DepartmentIds['Climate Control Corporation']].basePrice * 3,
	UpgradeIds.ClcExponent1
)

export default array
